<template>
  <v-container class="pa-0">
    <v-container class="wrapper pa-3">
      <v-container
        class="d-flex justify-start pa-0"
      >
        <v-btn
          color="primary"
          outlined
          @click="openPanelDialog('add')"
        >
          <span>{{ $t('add-new-panel') }}</span>
          <v-icon size="16" class="mr-1">mdi-plus</v-icon>
        </v-btn>
      </v-container>
      <v-container
        class="pa-0 mt-5 columns"
      >
        <v-container
          class="pa-4 column-panel d-flex justify-space-between align-center mt-2"
          v-for="(item, index) in items"
          :key="index"
        >
          <div class="d-flex align-center gap-3">
            <v-card-text class="pa-0 text-caption">{{ index + 1 }}</v-card-text>
            <v-card-text class="pa-0 text-body-2">{{ item.panel_name }}</v-card-text>
          </div>
          <div class="d-flex align-center gap-5">
            <v-card-text
              class="pa-0 text-body-2"
              :style="{'color': item.panel_status == 'active' ? '#137333' : '#ff5252'}"
            >
            {{ $t(item.panel_status) }}
            </v-card-text>
            <div @click="openPanelDialog('edit', item)">
              <svg style="cursor: pointer;" width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M2.66602 14.5002H13.3327M3.77668 9.29156C3.49243 9.57645 3.33275 9.96244 3.33268 10.3649V12.5002H5.48135C5.88402 12.5002 6.27002 12.3402 6.55468 12.0549L12.888 5.71822C13.1722 5.43329 13.3317 5.0473 13.3317 4.64489C13.3317 4.24248 13.1722 3.85649 12.888 3.57156L12.2627 2.94489C12.1217 2.80379 11.9542 2.69187 11.7699 2.61554C11.5856 2.5392 11.388 2.49994 11.1885 2.5C10.9891 2.50006 10.7915 2.53944 10.6073 2.6159C10.423 2.69235 10.2556 2.80437 10.1147 2.94556L3.77668 9.29156Z" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
          </div>
        </v-container>
        <v-container class="d-flex justify-space-between pa-0 mt-10">
          <v-btn
            color="primary"
            height="32"
            @click="submit"
            :loading="loading"
          >
          {{ $t('submit') }}
          </v-btn>
          <v-btn
            color="secondary"
            height="32"
            outlined
          >
          {{ $t('cancel') }}
          </v-btn>
        </v-container>
      </v-container>
    </v-container>
    <v-dialog
      v-model="panelDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      max-width="800"
    >
      <v-card class="pa-5">
        <v-form ref="form" v-model="valid">
          <v-container class="pa-0 d-flex justify-space-between align-center">
            <v-card-text class="pa-0 text-body-1">{{  dialogType == 'add' ? $t('add-new-panel') : $t('edit-panel') }}</v-card-text>
            <v-icon size="20" @click="panelDialog = false">mdi-close</v-icon>
          </v-container>
          <v-card-text class="pa-0 text-body-2 mt-7 mb-4">{{ $t('general-setting') }}</v-card-text>
          <v-container class="pa-0 d-flex gap-2">
            <v-text-field
              v-model="newPanel.panel_name"
              :label="$t('panel-title')"
              outlined
              height="32"
              dense
              style="width: 45px;"
              :rules="[v => !!v || $t('is-required')]"
            />
            <v-container
              class="wrapper-toggle d-flex align-center pa-0"
              style="width: 151px;"
            >
              <div
                v-for="(item, index) in activatorOptions"
                :key="index"
                @click="selectStatusPanel(item)"
                class="child flex-fill text-center"
                :style="{
                'background-color': selectedStatusPanel == item.value ? '#E5FEED' : '',
                'border-color': selectedStatusPanel == item.value ? '#0066ff' : 'silver',
                'color': selectedStatusPanel == item.value ? '#137333': ''
                }"
              >
                <v-card-text class="pa-0 text-caption">{{ item.label }}</v-card-text>
              </div>
            </v-container>
            <v-text-field
              v-if="newPanel && newPanel.configs"
              v-model="newPanel.configs.digikala_token"
              :label="$t('apiKey')"
              outlined
              height="32"
              dense
              :rules="[v => !!v || $t('is-required')]"
            />
          </v-container>
          <v-container class="pa-0 d-flex align-center gap-2 mt-5 mb-9">
              <v-text-field
                v-if="newPanel && newPanel.configs"
                v-model="newPanel.phone"
                :label="$t('phone-number')"
                outlined
                height="32"
                dense
                :rules="[v => !!v || $t('is-required')]"
              />
              <v-text-field
                v-if="newPanel && newPanel.configs"
                v-model="newPanel.configs.currency_coefficient"
                :label="$t('currency_coefficient')"
                outlined
                height="32"
                dense
                :rules="[v => !!v || $t('is-required')]"
              />
            </v-container>
          <v-card-text class="pa-0 text-body-2 mt-5 mb-2">{{ $t('return-invoices') }}</v-card-text>
          <v-container class="d-flex gap-3 pa-0">
            <v-card-text class="pa-0 text-body-2 mt-2">{{ $t('Select the desired option to register returned invoices') }}</v-card-text>
            <v-container
              class="wrapper-toggle d-flex align-center pa-0 ma-0"
              style="width: 200px;"
            >
              <div
                v-for="(item, index) in invoiceOptions"
                :key="index"
                @click="selectInvoiceOption(item)"
                class="child flex-fill text-center"
                :style="{
                'background-color': selectedInvoiceOption == item.value ? '#D9EEFF' : '',
                'border-color': selectedInvoiceOption == item.value ? '#0066ff' : 'silver',
                'color': selectedInvoiceOption == item.value ? '#0066FF' : ''
                }"
              >
                <v-card-text class="pa-0 text-caption">{{ item.label }}</v-card-text>
              </div>
            </v-container>
            <!-- <v-text-field
              :label="$t('panel-title')"
              outlined
              height="32"
              dense
              :disabled="selectedInvoiceOption == 'deleteInvoice'"
            /> -->
          </v-container>
          <v-card-text class="pa-0 text-body-2 mt-5 mb-2">{{ $t('entrepotToUse') }}</v-card-text>
          <v-container class="d-flex align-center gap-3 pa-0 mb-7">
            <v-card-text class="pa-0 text-body-2">{{ $t('inventory-update') }}</v-card-text>
            <v-container
              class="wrapper-toggle d-flex align-center pa-0 ma-0"
              style="width: 150px;"
            >
              <div
                v-for="(item, index) in activatorOptions"
                :key="index"
                @click="selectStatusInventoryUpdate(item)"
                class="child flex-fill text-center"
                :style="{
                'background-color': selectedStatusInventoryUpdate == item.value ? '#E5FEED' : '',
                'border-color': selectedStatusInventoryUpdate == item.value ? '#0066ff' : 'silver',
                'color': selectedStatusInventoryUpdate == item.value ? '#137333': ''
                }"
              >
                <v-card-text class="pa-0 text-caption">{{ item.label }}</v-card-text>
              </div>
            </v-container>
            <v-card-text class="pa-0 text-body-2">{{ $t('fixed-price-update') }}</v-card-text>
            <v-container
              class="wrapper-toggle d-flex align-center pa-0 ma-0"
              style="width: 150px;"
            >
              <div
                v-for="(item, index) in activatorOptions"
                :key="index"
                @click="selectStatusPriceUpdate(item)"
                class="child flex-fill text-center"
                :style="{
                'background-color': selectedStatusPriceUpdate == item.value ? '#E5FEED' : '',
                'border-color': selectedStatusPriceUpdate == item.value ? '#0066ff' : 'silver',
                'color': selectedStatusPriceUpdate == item.value ? '#137333': ''
                }"
              >
                <v-card-text class="pa-0 text-caption">{{ item.label }}</v-card-text>
              </div>
            </v-container>
          </v-container>
          <autocomplete
            v-model="newPanel.configs.seller_warehouse"
            :rules="[v => !!v || $t('is-required')]"
            :title="$t('Choosing a warehouse with the seller')"
            type="entrepot"
            style="width: 266px;"
          />
          <v-card-text class="pa-0 text-body-2 mt-9 mb-5">{{ $t('Warehouses that are created for this panel') }}</v-card-text>
          <!-- <v-text-field
            v-if="newPanel && newPanel.configs"
            v-model="newPanel.configs.digikala_warehouse"
            :label="$t('Warehouse near Digikala? (Panel title)')"
            outlined
            height="32"
            dense
            style="width: 266px;"
            :rules="[v => !!v || $t('is-required')]"
          /> -->
          <autocomplete
            v-if="newPanel && newPanel.configs"
            v-model="newPanel.configs.digikala_warehouse"
            :rules="[v => !!v || $t('is-required')]"
            :title="$t('Warehouse near Digikala? (Panel title)')"
            type="entrepot"
            style="width: 266px;"
          />
          <!-- <v-text-field
            v-if="newPanel && newPanel.configs"
            v-model="newPanel.configs.returns_digikala_warehouse"
            :label="$t('Return warehouse of digital goods? (Panel title)')"
            outlined
            height="32"
            dense
            style="width: 266px;"
            class="mt-9"
            :rules="[v => !!v || $t('is-required')]"
          /> -->
          <autocomplete
            v-if="newPanel && newPanel.configs"
            v-model="newPanel.configs.returns_digikala_warehouse"
            :rules="[v => !!v || $t('is-required')]"
            :title="$t('Return warehouse of digital goods? (Panel title)')"
            type="entrepot"
            style="width: 266px;"
            class="mt-9"
          />
          <v-container class="pa-0 d-flex align-center justify-space-between mt-10">
            <div class="d-flex align-center gap-1">
              <v-btn
                color="primary"
                height="32"
                @click="checkValidation"
              >
              {{ dialogType == 'add' ? $t('confirm') : $t('edit') }}
              </v-btn>
              <v-btn
                color="secondary"
                outlined
                height="32"
                @click="panelDialog = false"
              >
              {{ $t('cancel') }}
              </v-btn>
            </div>
            <v-btn
              color="error"
              outlined
              height="32"
              @click="openDeletePanel"
            >
            <span class="ml-1">{{ $t('delete-panel') }}</span>
            <svg width="15" height="15" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5.625 3.375H5.5C5.56875 3.375 5.625 3.31875 5.625 3.25V3.375ZM5.625 3.375H10.375V3.25C10.375 3.31875 10.4312 3.375 10.5 3.375H10.375V4.5H11.5V3.25C11.5 2.69844 11.0516 2.25 10.5 2.25H5.5C4.94844 2.25 4.5 2.69844 4.5 3.25V4.5H5.625V3.375ZM13.5 4.5H2.5C2.22344 4.5 2 4.72344 2 5V5.5C2 5.56875 2.05625 5.625 2.125 5.625H3.06875L3.45469 13.7969C3.47969 14.3297 3.92031 14.75 4.45312 14.75H11.5469C12.0813 14.75 12.5203 14.3313 12.5453 13.7969L12.9312 5.625H13.875C13.9438 5.625 14 5.56875 14 5.5V5C14 4.72344 13.7766 4.5 13.5 4.5ZM11.4266 13.625H4.57344L4.19531 5.625H11.8047L11.4266 13.625Z" fill="#ff5252"></path>
            </svg>
            </v-btn>
          </v-container>
        </v-form>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="deleteDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      max-width="350"
    >
      <v-card class="pa-5">
        <v-card-text class="pa-0 text-body-2">
            {{ $t('Are you sure you want to delete this item ?') }}
        </v-card-text>
        <v-container class="pa-0 d-flex align-center gap-2 mt-6">
            <v-btn
              color="error"
              height="32"
              @click="deletePanel"
              :loading="loading"
            >
            {{ $t('yes') }}
            </v-btn>
            <v-btn
              color="secondary"
              height="32"
              outlined
              @click="deleteDialog = false"
            >
            {{ $t('no') }}
            </v-btn>
        </v-container>
      </v-card>
    </v-dialog>
    <v-snackbar
      v-model="snakbar"
      :color="(snakbarColor ? snakbarColor : '')"
      top
      style="z-index: 1000000000000 !important;"
    >
      {{ snakbarText }}

      <template v-slot:action="{ attrs }">
        <v-btn
          color="white"
          text
          v-bind="attrs"
          @click="snakbar = !snakbar"
        >
          {{ $t('close') }}
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
export default {
  data () {
    return {
      panelDialog: false,
      selectedStatusPanel: null,
      selectedInvoiceOption: null,
      selectedStatusInventoryUpdate: null,
      selectedStatusPriceUpdate: null,
      snakbar: false,
      snakbarText: null,
      snakbarColor: null,
      dialogType: null,
      valid: true,
      selectedIndex: null,
      deleteDialog: false,
      items: [],
      userInfo: null,
      loading: false,
      selectedWarehouse: null,
      newPanel: {
        id: null,
        type: 'digikala',
        phone: null,
        abr_name: this.userInfo?.init?.abrName,
        abr_token: this.userInfo?.token,
        panel_name: null,
        panel_status: null,
        configs: Object.assign({}, {
          currency_coefficient: null,
          digikala_token: null,
          return_invoices_status: null,
          inventory_update: null,
          price_update: null,
          seller_warehouse: null,
          digikala_warehouse: null,
          returns_digikala_warehouse: null
        })
      }
    }
  },
  methods: {
    fetchPanelList () {
      var app = this
      app.$axios.get(this.$apipoint + 'config/digikala/list')
        .then(r => {
          this.items = r.data
        })
        .catch(err => {
          this.serverErrorHandeler(err)
        })
    },
    openPanelDialog (type, selectedItem) {
      this.panelDialog = true
      if (type == 'add') {
        // consider toggle buttons default (show)
        this.selectedStatusPanel = 'active'
        this.selectedInvoiceOption = 'register'
        this.selectedStatusInventoryUpdate = 'active'
        this.selectedStatusPriceUpdate = 'active'
        // insert defaults in objects
        this.newPanel.panel_status = this.selectedStatusPanel
        this.newPanel.configs.return_invoices_status = this.selectedInvoiceOption
        this.newPanel.configs.inventory_update = this.selectedStatusInventoryUpdate
        this.newPanel.configs.price_update = this.selectedStatusPriceUpdate

        this.dialogType = 'add'
      }
      if (type == 'edit' && selectedItem) {
        this.dialogType = 'edit'
        this.newPanel = {
          id: selectedItem.id,
          type: 'digikala',
          phone: selectedItem.phone,
          abr_name: this.userInfo?.init?.abrName,
          abr_token: this.userInfo?.token,
          panel_name: selectedItem.panel_name,
          panel_status: selectedItem.panel_status,
          configs: {
            currency_coefficient: selectedItem.configs.currency_coefficient,
            digikala_token: selectedItem.configs.digikala_token,
            return_invoices_status: selectedItem.configs.return_invoices_status,
            inventory_update: selectedItem.configs.inventory_update,
            price_update: selectedItem.configs.price_update,
            seller_warehouse: selectedItem.configs.seller_warehouse,
            digikala_warehouse: selectedItem.configs.digikala_warehouse,
            returns_digikala_warehouse: selectedItem.configs.returns_digikala_warehouse
          }
        }
        this.selectedStatusPanel = selectedItem.panel_status
        this.selectedInvoiceOption = selectedItem.configs.return_invoices_status
        this.selectedStatusInventoryUpdate = selectedItem.configs.inventory_update
        this.selectedStatusPriceUpdate = selectedItem.configs.price_update

        this.selectedIndex = this.items.findIndex(item => (item.panel_name == selectedItem.panel_name && item.configs.digikala_token == selectedItem.configs.digikala_token))
        /* console.log('selected index ' + this.selectedIndex) */
      }
    },
    selectStatusPanel (item) {
      this.selectedStatusPanel = item.value
      this.newPanel.panel_status = this.selectedStatusPanel
    },
    selectInvoiceOption (item) {
      this.selectedInvoiceOption = item.value
      this.newPanel.configs.return_invoices_status = this.selectedInvoiceOption
    },
    selectStatusInventoryUpdate (item) {
      this.selectedStatusInventoryUpdate = item.value
      this.newPanel.configs.inventory_update = this.selectedStatusInventoryUpdate
    },
    selectStatusPriceUpdate (item) {
      this.selectedStatusPriceUpdate = item.value
      this.newPanel.configs.price_update = this.selectedStatusPriceUpdate
    },
    checkValidation () {
      if (this.$refs.form.validate() && this.dialogType == 'add') {
        this.addPanel()
      }
      if (this.$refs.form.validate() && this.dialogType == 'edit') {
        this.editPanel()
      }
    },
    addPanel () {
      const sameObject = this.items.some(item => item.configs.digikala_token == this.newPanel.configs.digikala_token)
      if (!sameObject) {
        // add columns (show)
        this.items.push(this.newPanel)
        this.panelDialog = false
        /* console.log('items after add' + JSON.stringify(this.items)) */
      } else {
        this.snakbarText = this.$t('duplicate digikala token')
        this.snakbarColor = 'red'
        this.snakbar = true
      }
    },
    editPanel () {
      // edit column (show)
      this.items.splice(this.selectedIndex, 1, this.newPanel)
      this.panelDialog = false
      /* console.log('items after edit' + JSON.stringify(this.items)) */
    },
    openDeletePanel () {
      if (this.dialogType == 'add') {
        this.panelDialog = false
      }
      if (this.dialogType == 'edit') {
        this.deleteDialog = true
      }
    },
    submit () {
      // post api
      this.loading = true
      var app = this
      app.$axios.post(this.$apipoint + 'config/digikala/store', this.items)
        .then(r => {
          this.loading = false
          this.snakbarText = this.$t('new panel successfully added')
          this.snakbarColor = 'green'
          this.snakbar = true
        })
        .catch(err => {
          this.serverErrorHandeler(err)
        })
    },
    deletePanel () {
      // delete api
      this.loading = true
      const id = this.items[this.selectedIndex].id
      /* console.log(id) */
      if (id != null) {
        var app = this
        app.$axios.delete(this.$apipoint + `config/destroy/${id}`)
        .then(r => {
          if (r.data.status == 'success') {
            this.loading = false
            this.items.splice(this.selectedIndex, 1)
            this.deleteDialog = false
            this.panelDialog = false
            this.snakbarText = this.$t('your panel removed successfully')
            this.snakbarColor = 'red'
            this.snakbar = true
          }
        })
        .catch(err => {
          this.serverErrorHandeler(err)
        })
      } else {
        this.loading = false
        this.items.splice(this.selectedIndex, 1)
        this.panelDialog = false
        this.deleteDialog = false
        this.snakbarText = this.$t('your panel removed successfully')
        this.snakbarColor = 'red'
        this.snakbar = true
      }
    }
  },
  mounted () {
    this.fetchPanelList()
    this.userInfo = JSON.parse(localStorage.getItem('token'))
  },
  computed: {
    activatorOptions () {
      return [
        { label: this.$t('active'), value: 'active' },
        { label: this.$t('deactive'), value: 'deactive' }
      ]
    },
    invoiceOptions () {
      return [
        { label: this.$t('registration-of-returned-invoice'), value: 'register' },
        { label: this.$t('delete-invoice'), value: 'delete' }
      ]
    }
  },
  watch: {
    panelDialog (val) {
      if (!val) {
        // reset keys
        this.newPanel = {
          id: null,
          type: 'digikala',
          phone: null,
          abr_name: this.userInfo?.init?.abrName,
          abr_token: this.userInfo?.token,
          panel_name: null,
          panel_status: null,
          configs: {
            currency_coefficient: null,
            digikala_token: null,
            return_invoices_status: null,
            inventory_update: null,
            price_update: null,
            seller_warehouse: null,
            digikala_warehouse: null,
            returns_digikala_warehouse: null
          }
        }
        // reset form
        this.$refs.form.reset()
        // reset toggle button
        this.selectedStatusPanel = null
        this.selectedInvoiceOption = null
        this.selectedStatusInventoryUpdate = null
        this.selectedStatusPriceUpdate = null

        this.newPanel.panel_status = null
        this.newPanel.configs.return_invoices_status = null
        this.newPanel.configs.inventory_update = null
        this.newPanel.configs.price_update = null
      }
    },
    userInfo: {
      handler(val) {
          if (val?.init) {
            this.newPanel.abr_name = val.init.abrName || null
            this.newPanel.abr_token = val.token || null
          }
      },
      deep: true,
      immediate: true
    }
  }
}
</script>

<style scoped>
.wrapper {
  background-color: #FCFCFC;
}
.wrapper .columns .column-panel {
  border: 1px solid silver;
  border-radius: 4px;
}
.v-card__text {
  width: auto;
}
.wrapper-toggle {
  border: 1px solid silver;
  border-radius: 4px;
}
.wrapper-toggle .child {
  padding: 7.7px;
  cursor: pointer;
  border-radius: 4px;
}
.wrapper-toggle .child:first-child {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.wrapper-toggle .child:nth-child(2) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
</style>
